document.addEventListener('DOMContentLoaded', function () {
  var bar = document.querySelector('[data-kaamo-sticky-atc]');
  if (!bar) return;

  var realButton = document.querySelector('product-form button[name="add"], .product-form button[name="add"]');
  var anchor = document.querySelector('.product-form__buttons') || realButton;

  if (!realButton || !anchor) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('kaamo-sticky-atc--visible');
        } else if (entry.boundingClientRect.top < 0) {
          bar.hidden = false;
          requestAnimationFrame(function () {
            bar.classList.add('kaamo-sticky-atc--visible');
          });
        }
      });
    },
    { threshold: 0 }
  );

  observer.observe(anchor);

  var stickyButton = bar.querySelector('[data-kaamo-sticky-atc-button]');
  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      if (realButton.disabled) return;
      realButton.click();
    });
  }
});
